export const isProductionEnv =
  process.env.NODE_ENV !== 'development' &&
  !localStorage.getItem('TK_DEV_MACHINE');

console.log({ isProductionEnv });
